import { Check, X, Minus } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const rows = [
  {
    feature: "Turnaround",
    traditional: "Days or weeks",
    appellate: "15\u201330 minutes",
    tradIcon: "bad",
    appIcon: "good",
  },
  {
    feature: "Pricing",
    traditional: "$5,000\u2013$20,000",
    appellate: "Software-first pricing",
    tradIcon: "bad",
    appIcon: "good",
  },
  {
    feature: "Workflow",
    traditional: "Labor-heavy",
    appellate: "Fully automated",
    tradIcon: "bad",
    appIcon: "good",
  },
  {
    feature: "Transparency",
    traditional: "Limited",
    appellate: "Fast, consistent output",
    tradIcon: "mid",
    appIcon: "good",
  },
  {
    feature: "Economics",
    traditional: "Service business",
    appellate: "Platform economics",
    tradIcon: "mid",
    appIcon: "good",
  },
  {
    feature: "Scalability",
    traditional: "Linear cost growth",
    appellate: "Software-driven scale",
    tradIcon: "bad",
    appIcon: "good",
  },
];

function StatusIcon({ type }) {
  if (type === "good")
    return (
      <div className="w-4 h-4 rounded-full bg-blue-100 flex items-center justify-center">
        <Check className="h-2.5 w-2.5 text-blue-600" />
      </div>
    );
  if (type === "bad")
    return (
      <div className="w-4 h-4 rounded-full bg-red-50 flex items-center justify-center">
        <X className="h-2.5 w-2.5 text-red-400" />
      </div>
    );
  return (
    <div className="w-4 h-4 rounded-full bg-slate-100 flex items-center justify-center">
      <Minus className="h-2.5 w-2.5 text-slate-400" />
    </div>
  );
}

export default function CompetitionSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-competition-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        COMPETITIVE LANDSCAPE
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Manual service providers dominate &mdash; not real software platforms
      </h1>

      <div className="flex-1 min-h-0">
        <Table data-testid="competition-table">
          <TableHeader>
            <TableRow className="border-slate-200">
              <TableHead className="font-heading text-xs font-semibold text-slate-900 w-[130px]">
                Feature
              </TableHead>
              <TableHead className="font-heading text-xs font-semibold text-slate-500">
                Manual / Traditional
              </TableHead>
              <TableHead className="font-heading text-xs font-semibold text-blue-600">
                AppellatePro.AI
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} className="border-slate-100">
                <TableCell className="font-body text-xs font-medium text-slate-700 py-2.5">
                  {row.feature}
                </TableCell>
                <TableCell className="py-2.5">
                  <div className="flex items-center gap-2">
                    <StatusIcon type={row.tradIcon} />
                    <span className="font-body text-xs text-slate-500">
                      {row.traditional}
                    </span>
                  </div>
                </TableCell>
                <TableCell className="py-2.5">
                  <div className="flex items-center gap-2">
                    <StatusIcon type={row.appIcon} />
                    <span className="font-body text-xs text-slate-700 font-medium">
                      {row.appellate}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <p className="text-sm text-slate-400 font-body mt-3 text-center">
        No dominant software-first player has become the default platform for
        this workflow.
      </p>
    </div>
  );
}
